export default "__VITE_ASSET__BTUNHLqi__"